import { render, staticRenderFns } from "./Mytask.vue?vue&type=template&id=1765657c&scoped=true&"
import script from "./Mytask.vue?vue&type=script&lang=js&"
export * from "./Mytask.vue?vue&type=script&lang=js&"
import style0 from "./Mytask.vue?vue&type=style&index=0&id=1765657c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1765657c",
  null
  
)

export default component.exports